// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../img/hero_bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:wght@400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  overflow: auto;
}
.swiper {
  padding-bottom: 3.6rem !important;
}
.hero-wrapper {
  background: radial-gradient(
    393.95% 194.46% at -11.83% 213.72%,
    #59d3c2 0%,
    #0371e8 100%
  );
  z-index: 1;
  @media only screen and (min-width: 1280px) {
    position: relative;
  }
  
}
.hero-background {
  position: absolute;
  z-index: -2;
  opacity: 0.25;
  width: 100%;
  height: 100%;
  opacity: 0.5;

  @media only screen and (min-width: 1280px) {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-size: 887px 701px;
    background-repeat: no-repeat;
    background-position: 100% 110%;
  }
  
}
.hero-content {
  position: relative;
  /* z-index: 99999 !important; */
}
.hero-clip {
  clip-path: ellipse(102% 82% at 0% 13%);
  width: 100%;
  height: 200px;
  position: relative;
  background: #0371e8;
}

.custom-shape-divider-bottom {
  position: relative;
  bottom: 0;
  top: -48px;
  left: 0;

  position: absolute;
  top: 93%;
  left: 0;
  right: 0;

  z-index: 1;
  overflow: hidden;
  line-height: 0;
}

.custom-shape-divider-bottom svg {
  position: relative;
  display: block;
  /* width: calc(100% + 1.3px); */
  width: 100%;
  height: 49px;
  transform: rotateY(180deg);
}

.custom-shape-divider-bottom .shape-fill {
  fill: #eff1f4;
}
/* CSS */
.ring {
  border-radius: 50%;
  box-sizing: border-box;
  border-color: #006fe8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ring2 {
  border-radius: 50%;
  box-sizing: border-box;
  border-color: #006fe8;
}

.ring-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  opacity: 0.1;
  position: absolute;
  overflow: hidden;
}


.bg-quoter-landscape {
  
  @media only screen and (max-width: 640px) {
    padding-top: 4rem;
    background: radial-gradient(
    393.95% 194.46% at -11.83% 213.72%,
    #59d3c2 0%,
    #0371e8 100%
  );
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/core.css"],"names":[],"mappings":"AAGA;;EAEE,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE;;;;GAIC;EACD,UAAU;EACV;IACE,kBAAkB;EACpB;;AAEF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;;EAEZ;IACE,6DAA+C;IAC/C,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;EAChC;;AAEF;AACA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,OAAO;;EAEP,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;;EAER,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;AACA,QAAQ;AACR;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;;EAEE;IACE,iBAAiB;IACjB;;;;GAID;EACD;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Titillium+Web:wght@400;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap\");\n\nbody,\nhtml {\n  overflow: auto;\n}\n.swiper {\n  padding-bottom: 3.6rem !important;\n}\n.hero-wrapper {\n  background: radial-gradient(\n    393.95% 194.46% at -11.83% 213.72%,\n    #59d3c2 0%,\n    #0371e8 100%\n  );\n  z-index: 1;\n  @media only screen and (min-width: 1280px) {\n    position: relative;\n  }\n  \n}\n.hero-background {\n  position: absolute;\n  z-index: -2;\n  opacity: 0.25;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n\n  @media only screen and (min-width: 1280px) {\n    background: url(./../img/hero_bg.svg) no-repeat;\n    background-size: 887px 701px;\n    background-repeat: no-repeat;\n    background-position: 100% 110%;\n  }\n  \n}\n.hero-content {\n  position: relative;\n  /* z-index: 99999 !important; */\n}\n.hero-clip {\n  clip-path: ellipse(102% 82% at 0% 13%);\n  width: 100%;\n  height: 200px;\n  position: relative;\n  background: #0371e8;\n}\n\n.custom-shape-divider-bottom {\n  position: relative;\n  bottom: 0;\n  top: -48px;\n  left: 0;\n\n  position: absolute;\n  top: 93%;\n  left: 0;\n  right: 0;\n\n  z-index: 1;\n  overflow: hidden;\n  line-height: 0;\n}\n\n.custom-shape-divider-bottom svg {\n  position: relative;\n  display: block;\n  /* width: calc(100% + 1.3px); */\n  width: 100%;\n  height: 49px;\n  transform: rotateY(180deg);\n}\n\n.custom-shape-divider-bottom .shape-fill {\n  fill: #eff1f4;\n}\n/* CSS */\n.ring {\n  border-radius: 50%;\n  box-sizing: border-box;\n  border-color: #006fe8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ring2 {\n  border-radius: 50%;\n  box-sizing: border-box;\n  border-color: #006fe8;\n}\n\n.ring-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n  opacity: 0.1;\n  position: absolute;\n  overflow: hidden;\n}\n\n\n.bg-quoter-landscape {\n  \n  @media only screen and (max-width: 640px) {\n    padding-top: 4rem;\n    background: radial-gradient(\n    393.95% 194.46% at -11.83% 213.72%,\n    #59d3c2 0%,\n    #0371e8 100%\n  );\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
